export default __webpack_public_path__ + "static/media/graphitprediccion.770ea638.png";